export default {"src":"/_next/static/media/ADV.34d4c367.svg","height":18,"width":18};